import { translateKeys } from '@atc/bonnet-parameters';

// TODO add to bonnet-parameters
const targets = ['cs', 'lsc'];
export default function handleLegacyParams() {
  let {
    target = 'lsc',
    reverse = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ctx => {
    // Deprecate reverse
    if (reverse) {
      // eslint-disable-next-line no-console
      console.log("[@atc/bonnet-ctx-legacy-plugin] reverse configuration option is deprecated.  Please use { target: <String> 'lsc', 'cs' } ");
      target = 'cs';
    }
    if (ctx.data && ctx.data.legacyParamsTarget) {
      target = ctx.data.legacyParamsTarget;
    }
    if (targets.includes(target)) {
      ctx.query = translateKeys(ctx.query, {
        target
      });
    }

    // Register the middleware so that subsequent middleware can be aware
    ctx.registerMiddleware('legacy-params');
  };
}